'use client';

import MiniPicks from '@web-landing/components/SearchPicks/MiniPicks/MiniPicks';
import {AppFromBackapi} from '@web-landing/components/SearchPicks/MiniPicks/MiniPicks.types';
import StrapiBackgroundImage from '@web-landing/components/StrapiImages/StrapiBackgroundImage';

import {SingleImageWithoutNull} from '@web-landing/strapi/types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import styles from './GamesMonth.module.scss';

type Props = {
  title: string;
  buttonText: string;
  apps: AppFromBackapi[];
  backgroundImage: SingleImageWithoutNull;
};

export const GamesMonth = ({
  backgroundImage,
  apps,
  buttonText,
  title,
}: Props) => {
  const onClick = () => {
    logTmrEvent(EVENTS.landingClick, {
      button_text: buttonText,
      element_type: 'button',
    });
  };

  return (
    <StrapiBackgroundImage
      imageData={backgroundImage}
      className={styles.wrapper}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <a
            onClick={onClick}
            href="https://www.rustore.ru/catalog/games"
            className={styles.link}
          >
            {buttonText}
          </a>
        </div>
        <MiniPicks apps={apps} metricsName="GamesMonth" />
      </div>
    </StrapiBackgroundImage>
  );
};
